import React from 'react';
import BoltRoundedIcon from '@mui/icons-material/BoltRounded';
import ErrorOutlineRoundedIcon from '@mui/icons-material/ErrorOutlineRounded';
import ScheduleRoundedIcon from '@mui/icons-material/ScheduleRounded';
import WorkspacesRoundedIcon from '@mui/icons-material/WorkspacesRounded';
import Box from '@mui/material/Box';
import Card from '@mui/material/Card';
import Skeleton from '@mui/material/Skeleton';
import Stack from '@mui/material/Stack';
import Typography from '@mui/material/Typography';
import { alpha } from '@mui/material/styles';

const items = [
  { key: 'active', label: 'Active Workspaces', helper: 'Current work', icon: WorkspacesRoundedIcon, color: 'primary' },
  { key: 'attention', label: 'Need Attention', helper: 'Action required', icon: ErrorOutlineRoundedIcon, color: 'warning' },
  { key: 'execution', label: 'In Execution', helper: 'Runs or work active', icon: BoltRoundedIcon, color: 'info' },
  { key: 'recentlyUpdated', label: 'Recently Updated', helper: 'Last 7 days', icon: ScheduleRoundedIcon, color: 'success' },
];

export default function WorkspaceSummaryStrip({ summary, loading = false }) {
  return (
    <Box
      aria-label="Workspace summary"
      sx={{
        display: 'grid',
        gridTemplateColumns: {
          xs: 'repeat(2, minmax(0, 1fr))',
          lg: 'repeat(4, minmax(0, 1fr))',
        },
        gap: 1.5,
      }}
    >
      {items.map(({ key, label, helper, icon: Icon, color }) => (
        <Card
          key={key}
          variant="outlined"
          sx={{
            borderRadius: 2.5,
            boxShadow: 'none',
            minWidth: 0,
          }}
        >
          <Stack direction="row" spacing={1.5} alignItems="center" sx={{ p: 1.75 }}>
            <Box
              sx={(theme) => ({
                width: 36,
                height: 36,
                flex: '0 0 auto',
                borderRadius: 2,
                display: 'grid',
                placeItems: 'center',
                color: theme.palette[color].main,
                bgcolor: alpha(theme.palette[color].main, 0.1),
              })}
            >
              <Icon fontSize="small" />
            </Box>
            <Box sx={{ minWidth: 0 }}>
              <Stack direction="row" spacing={1} alignItems="baseline">
                {loading ? (
                  <Skeleton width={28} height={30} />
                ) : (
                  <Typography variant="h6" sx={{ fontWeight: 800, lineHeight: 1.15 }}>
                    {summary[key]}
                  </Typography>
                )}
                <Typography
                  variant="body2"
                  noWrap
                  sx={{ fontWeight: 700, display: { xs: 'none', sm: 'block' } }}
                >
                  {label}
                </Typography>
              </Stack>
              <Typography variant="caption" color="text.secondary" noWrap>
                <Box component="span" sx={{ display: { sm: 'none' } }}>{label} · </Box>
                {helper}
              </Typography>
            </Box>
          </Stack>
        </Card>
      ))}
    </Box>
  );
}
